import AppTranslation from 'entities/AppTranslation';
import Language from './Language';

export interface AppTextTranslations {
  [key: string]: AppTranslation;
}

export interface AppText {
  reference: string;
  id: string;
  key?: string;
  translations: AppTextTranslations;
  isOptionSet: boolean;
  optionSetId?: string;
  optionSetKey?: string;
  optionSetValueId?: string;
  optionSetValueKey?: string;
}

export const generateAppTextOptionSetTranslationValue = function (
  appTexts: AppText[],
  appTextId: string,
  languageCode: string,
): string {
  let translationValue = '';

  appTexts.forEach((appText, index) => {
    if (appText.isOptionSet && appText.id === appTextId) {
      const translation = appText.translations[languageCode];
      if (translation) {
        translationValue += `[${appText.optionSetValueKey}]${translation.value}[${appText.optionSetValueKey}]\n`;
      }
    }
  });

  return translationValue;
};

export const appTextHasMissingValue = (
  appText: AppText,
  languages: Language[],
): boolean => {
  return Object.entries(appText.translations).some(
    ([languageCode, translation]) =>
      languages.find((language) => languageCode === language.code) &&
      translation.value.trim() === '',
  );
};

export default AppText;
